export interface User {
  id: number;
  profile_id: number | null;
  role_id: number;
  name: string;
  email: string;
  mobile: string | null;
  email_verified_at: string | null;
  is_active: number;
  created_by: number | null;
  updated_by: number | null;
  created_at: string | null;
  updated_at: string | null;
  deleted_at: string | null;
}

export interface userMenuAccess {
  menu_tree: MenuTree[] | [];
  slug_array: { [parent_slug: string]: string[] } | {};
}

export interface MenuTree {
  id: number;
  menu_name: string;
  menu_slug: string;
  url: string;
  sequence: number;
  sub_menus: MenuTree[] | null;
}

export interface AuthState {
  user: User | null;
  id: number | null;
  token: string | null;
  roleId: number | null;
  isLoading: boolean;
  error: string | null;
  permissions: userMenuAccess | null;
}

export const initialAuthState: AuthState = {
  user: null,
  id: null,
  token: null,
  roleId: null,
  isLoading: false,
  error: null,
  permissions: null
};


export interface persmissionMap {
  [menuSlug: string]: {
    route: string;
    component: string[],
    actions: string[];
  };
}

